import {format, parseISO} from 'date-fns/esm';
import {parseDate} from './datetime';

/**
 * Create a Blob containing JSON-serialized data.
 * Useful for easily creating JSON fetch request bodies.
 *
 * @param body The object to be serialized to JSON.
 * @param replacer A function that will replace values based on key with another value, by default it will replace 
 * dates without timezone component
 * @param properties Properties that should have the replacer used on them
 * @returns A Blob containing the JSON serialized body.
 */
export function convertToJson(body: any, replacer?: (k: string, v: any) => Object, timezone?: string,...properties: string[]): Blob {
  Date.prototype.toJSON = function() {
    return format(this, 'yyyy-MM-dd\'T\'HH:mm:ss.SSSxx');
  };
  if (!timezone) {
    timezone = '+10:00'
  }
  
  if (!replacer) {
    replacer = (key: string, value: any) => {
      // strip out timezone component
      if (typeof value === 'string'
        // match 'YYYY-MM-DDTHH:mm:ss.SSSZZ' datetime format
        && value.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}[+-]\d{4}/)) {
        return value.slice(0, 23)+timezone;
      }
      return value;
    };
  }
  const outerReplacer = properties.length === 0 ?
    replacer : (key: string, value: any) => {
      if (properties.indexOf(key) !== -1) {
        return replacer(key, value);
      }
      return value;
    };
  const returnObj = new Blob([JSON.stringify(body, outerReplacer)], { type: 'application/json' });
  Date.prototype.toJSON = function() {
    return this.toISOString();
  };
  return returnObj;
}

/**
 * Parses json response from Http Client into object
 * This is useful for parsing string in json objects to dates
 *
 * @param jsonString The json string to be serialized to an object.
 * @param dateFormat dateFormat string - format is from momentjs
 * @param properties Properties that should have JSON.parse(value) called on them. Mostly used to specify which 
 * properties should be parsed as dates.
 * @returns a javascript object
 */
export function parseJsonToObject(jsonString: any, ...properties: string[]): any {
  return JSON.parse(jsonString, (key, value) => {
    if (properties.indexOf(key) >= 0) {
      if (value) {
        return parseDate(value);
      } else {
        return value;
      }
    } else {
      return value;
    }
  });
}



// WEBPACK FOOTER //
// src/../~/wc-lib/src/wc-converters/json.ts